import styled, { css } from 'styled-components';

export const Container = styled.div<{ isLoading: boolean }>`
  display: flex;

  flex-direction: column;
  border-radius: 4px;
  border: solid 1px;
  border-color: ${({ theme }) => theme.colors.gray};
  background-color: ${({ theme }) => theme.colors.white};
  overflow: hidden;
  min-height: 205px;
  padding: 10px;
  ${({ isLoading }) =>
    isLoading
      ? css`
          display: flex;
          align-items: center;
          justify-content: center;
        `
      : ''};
`;

export const Footer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  font-size: 0.8125rem;

  span {
    font-size: 0.75rem;
    color: ${({ theme }) => theme.colors.white};
  }

  p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
  }
`;

export const MediaContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.gray};
  border-radius: 4px;
  height: 8rem;
`;

export const DownloadIconContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  opacity: 0;

  transition: opacity 0.3s;
`;

export const ArquiveContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
  cursor: pointer;

  :hover {
    ${DownloadIconContainer} {
      opacity: 1;
    }
  }
`;

export const ImageContainer = styled.div<{ srcImage: string; disableHoverOpacity?: boolean }>`
  height: 100%;
  background-image: url(${({ srcImage }) => srcImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: opacity 0.3s;
  border-radius: 4px;

  :hover {
    opacity: ${({ disableHoverOpacity }) => !disableHoverOpacity && 0.5};
  }
`;

export const VideoIconContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(0, 0, 0, 0.3);
  cursor: pointer;
  transition: background-color 0.3s;

  :hover {
    background-color: rgb(0, 0, 0, 0.5);
  }
`;
